import { createSvgIcon } from '@automata/mui-theme';
export const PlaceholderIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 17.5H78C78.2761 17.5 78.5 17.7239 78.5 18V78C78.5 78.2761 78.2761 78.5 78 78.5H18C17.7239 78.5 17.5 78.2761 17.5 78V18C17.5 17.7239 17.7239 17.5 18 17.5Z"
      stroke="#414141"
      strokeWidth="3"
    />
  </svg>,
  'PlaceholderIcon'
);
